<template>
	<div>
		<h2 v-if="heading" class="c-toc__heading">{{ heading }}</h2>
		<ul v-scroll-spy-active v-scroll-spy-link class="c-toc__list">
			<slot></slot>
		</ul>
	</div>
</template>

<script>
import Vue from "vue";
import scrollSpy, { Easing } from "vue2-scrollspy";

Vue.use(scrollSpy, {
	easing: Easing.Cubic.In
});

export default {
	name: "VToc",
	components: {
		scrollSpy
	},
	props: {
		heading: {
			type: String
		},
		className: {
			type: String
		}
	}
};
</script>
